import React, { useMemo } from 'react';
import StaffNamePanel from 'design-v2/common/StaffName';
import { quickValidationActions } from 'internal-reducers/quickValidation/slice';
import { useAppDispatch } from 'appRoot/Store';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import {
  BookingCreatorPanelType,
  IValidationErrorListItem,
} from 'external-services/booking-validation-service/bookingValidation.types';
import style from './style.module.css';

const StaffNamePanelContainer = ({ isDisplay }: { isDisplay?: boolean }) => {
  const dispatch = useAppDispatch();

  // prettier-ignore
  const quickSaveAttempted = useSelector((state: DiaryRootState) => state.quickValidationReducer.quickSaveAttempted);
  // prettier-ignore
  const cantSaveMessageList = useSelector((state: DiaryRootState) => state.quickValidationReducer.cantSaveMessageList);

  const updateStaffName = (name: string) => {
    dispatch(quickValidationActions.setStaffValue(name));
  };

  const isWarningPanel = useMemo(() => {
    return (
      quickSaveAttempted &&
      cantSaveMessageList.some(
        (item: IValidationErrorListItem) => item.panel === BookingCreatorPanelType.staff
      )
    );
  }, [quickSaveAttempted, cantSaveMessageList]);

  // set name to empty string in case not trigger useEffect in StaffNamePanel
  return (
    <div
      className={classNames({
        [style.hidden]: !isDisplay,
      })}
      data-testid={'staff-name-panel'}
    >
      <StaffNamePanel name={''} handleChange={updateStaffName} showWarning={isWarningPanel} />
    </div>
  );
};

export default StaffNamePanelContainer;
